// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from "react";

import { getLocalStorage } from "window-getters";
import { safeJsonStringify } from "safe-json-utils";

import {
  DEFAULT_BUTTON_COLOR,
  MOBILE_LINK_LOCALSTORAGE_KEY,
  WALLETCONNECT_CTA_TEXT_ID,
} from "../constants";

import { MOBILE_REGISTRY } from "../assets/registry";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ConnectButton from "./ConnectButton";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import WalletButton from "./WalletButton";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import WalletIcon from "./WalletIcon";
import { QRCodeModalOptions, TextMap } from "../../types";
import { MobileRegistryEntry } from "../../types/registry";
import { isIOS } from "../../utils";

function setLocal(key: string, data: any): void {
  const raw = safeJsonStringify(data);
  const local = getLocalStorage();
  if (local) {
    local.setItem(key, raw);
  }
}

function formatIOSMobile(uri: string, entry: MobileRegistryEntry) {
  const encodedUri: string = encodeURIComponent(uri);
  return entry.universalLink
    ? `${entry.universalLink}/wc?uri=${encodedUri}`
    : entry.deepLink
    ? `${entry.deepLink}${entry.deepLink.endsWith(":") ? "//" : "/"}wc?uri=${encodedUri}`
    : "";
}

function saveMobileLinkInfo(data: IMobileLinkInfo) {
  const focusUri = data.href.split("?")[0];
  setLocal(MOBILE_LINK_LOCALSTORAGE_KEY, { ...data, href: focusUri });
}

function getMobileRegistryEntry(name: string): MobileRegistryEntry {
  return MOBILE_REGISTRY.filter((entry: MobileRegistryEntry) =>
    entry.name.toLowerCase().includes(name),
  )[0];
}

function getMobileLinkRegistry(qrcodeModalOptions?: QRCodeModalOptions) {
  let links = MOBILE_REGISTRY;
  if (
    qrcodeModalOptions &&
    qrcodeModalOptions.mobileLinks &&
    qrcodeModalOptions.mobileLinks.length
  ) {
    links = qrcodeModalOptions.mobileLinks.map((name: string) => getMobileRegistryEntry(name));
  }
  return links;
}

interface IMobileLinkInfo {
  name: string;
  href: string;
}
interface MobileLinkDisplayProps {
  qrcodeModalOptions?: QRCodeModalOptions;
  text: TextMap;
  uri: string;
}

function MobileLinkDisplay(props: MobileLinkDisplayProps) {
  const ios = isIOS();
  const links = getMobileLinkRegistry(props.qrcodeModalOptions);
  const [showMore, setShowMore] = React.useState(false);
  const grid = links.length > 5;
  const displayShowMore = links.length > 12;
  return (
    <div>
      <p id={WALLETCONNECT_CTA_TEXT_ID} className="walletconnect-qrcode__text">
        {ios ? props.text.choose_preferred_wallet : props.text.connect_mobile_wallet}
      </p>
      <div
        className={`walletconnect-connect__buttons__wrapper${
          !ios ? "__android" : grid ? "__wrap" : ""
        }`}
      >
        {ios ? (
          links.map((entry: MobileRegistryEntry, idx: number) => {
            const { color, name, shortName, logo } = entry;
            const href = formatIOSMobile(props.uri, entry);
            const handleClickIOS = React.useCallback(() => {
              saveMobileLinkInfo({
                name,
                href,
              });
            }, []);
            if (idx > 11 && !showMore) return;
            return !grid ? (
              <WalletButton
                color={color}
                href={href}
                name={name}
                logo={logo}
                onClick={handleClickIOS}
              />
            ) : (
              <WalletIcon
                color={color}
                href={href}
                name={shortName}
                logo={logo}
                onClick={handleClickIOS}
              />
            );
          })
        ) : (
          <ConnectButton
            name={props.text.connect}
            color={DEFAULT_BUTTON_COLOR}
            href={props.uri}
            onClick={React.useCallback(() => {
              saveMobileLinkInfo({
                name: "Unknown",
                href: props.uri,
              });
            }, [])}
          />
        )}
      </div>
      {!!(ios && displayShowMore) && (
        <div className="walletconnect-modal__footer">
          <a onClick={() => setShowMore(!showMore)}>
            {showMore ? props.text.show_less : props.text.show_more}
          </a>
        </div>
      )}
    </div>
  );
}

export default MobileLinkDisplay;
